import { defBreadcrumb, siaranPersBreadcrumb } from '../../../data/DataBreadcrumb'
import { BlogBanner } from 'src/components/BlogPost/BlogBanner'
import { BlogWysiwyg } from 'src/components/BlogPost/BlogWysiwyg'
import Layout from 'src/components/Layout'
import NextHead from 'src/components/Seo/NextHead'
import { SocialMediaShareBar } from 'src/components/SocialMedia/SocialMediaShareBar'
import BreadcrumbComponent from 'src/components/UserInterface/BreadcrumbComponent'
import LayoutCenter from 'src/components/UserInterface/LayoutCenter'
import { BlogTitle } from 'src/components/BlogPost/BlogTitle'
import { getImageUrl, getSiaranPers } from 'src/utils/magnolia'
import { useState, useEffect } from 'react'
import { breadcrumb } from 'src/components/tentang-perusahaan/general'
import UseWindowSize from 'src/components/UseWindowSize'
import { scrollDetector } from 'src/utils/scroll-detector'

export const DetailSiaranPers = props => {
  const { data, asPath, itemsForBreadCrumb } = props
  const { width } = UseWindowSize()
  const [winSize, setWinSize] = useState(null)
  useEffect(() => {
    setWinSize(width)
    scrollDetector('sticky-share-socmend', 'socmed-share-wrapper')
  }, [])
  const banner = data?.banner && getImageUrl(data?.banner)
  return (
    <Layout>
      <NextHead title={data && data.title} url={asPath} breadcrumb={breadcrumb}></NextHead>
      <BreadcrumbComponent items={itemsForBreadCrumb} />
      <BlogBanner img={banner} alt={data.title} />
      <BlogTitle title={data.title} date={data.date} />
      <SocialMediaShareBar title={data.title} />
      <BlogWysiwyg innerHtml={data.content} />
      {winSize > 600 && (
        <LayoutCenter
          id="sticky-share-socmend"
          style={{ display: 'none' }}
          margin="0"
          position="sticky"
          bottom="0"
          backgroundColor="white"
          width="100%"
          widthLayout="100%"
          boxShadow
          index="0"
        >
          <LayoutCenter margin="0" justifyDesktop="flex-end">
            <p>Bagikan</p>
            <SocialMediaShareBar WidthAuto title={data.title} />
          </LayoutCenter>
        </LayoutCenter>
      )}
    </Layout>
  )
}

DetailSiaranPers.getInitialProps = async ({ res, query, asPath }) => {
  const { slug } = query
  try {
    const { data, status } = await getSiaranPers({
      params: {
        limit: 1,
        slug
      }
    })
    if (status === 200) {
      const dataPers = data.results[0]
      const breadcrumb = [
        ...defBreadcrumb,
        {
          '@type': 'ListItem',
          position: '2',
          item: {
            '@id': process.env.baseUrl + '/siaran-pers',
            name: 'Siaran Pers'
          }
        },
        {
          '@type': 'ListItem',
          position: '3',
          item: {
            '@id': process.env.baseUrl + asPath,
            name: dataPers.title
          }
        }
      ]
      const itemsForBreadCrumb = [
        ...siaranPersBreadcrumb,
        {
          page: dataPers.title,
          href: `/${slug}`,
          to: `/${slug}`
        }
      ]
      return {
        data: dataPers,
        asPath,
        itemsForBreadCrumb,
        breadcrumb
      }
    } else {
      if (res) {
        res.writeHead(301, {
          Location: `/halaman-tidak-ditemukan?q=${slug}`
        })
        res.end()
      }
      return
    }
  } catch (error) {
    if (res) {
      res.writeHead(301, {
        Location: `/halaman-tidak-ditemukan?q=${slug}`
      })
      res.end()
    }
    return
  }
}

export default DetailSiaranPers
